<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('routes.employeesOverdueDocumentsByRegisterBooks') }}</h1>
        </div>
        <div class="level-right">
          <div class="control">
            <button @click="loadData(true)" class="button is-success">{{ $t('interface.export') }}</button>
          </div>
        </div>
      </div>
      <div class="mobile-scroll" ref="report">
        <table class="report-table" border="1">
          <thead>
          <tr>
            <td class="has-text-centered" width="25%">{{ $t('reports.fullname') }}</td>
            <td class="has-text-centered">{{ $t('reports.registerBook1') }}</td>
            <td class="has-text-centered">{{ $t('reports.registerBook2') }}</td>
            <td class="has-text-centered">{{ $t('reports.registerBook3') }}</td>
            <td class="has-text-centered">{{ $t('reports.registerBook4') }}</td>
            <td class="has-text-centered">{{ $t('reports.appeals') }}</td>
            <td class="has-text-centered">{{ $t('reports.other') }}</td>
          </tr>
          </thead>
          <tbody>
          <template v-for="employee in employeesOverdueDocumentsByRegisterBooksData"
                    v-if="employee">
            <tr>
              <td>{{ employee.fullname }}</td>
              <td class="has-text-centered">{{ employee.rb1 }}</td>
              <td class="has-text-centered">{{ employee.rb2 }}</td>
              <td class="has-text-centered">{{ employee.rb3 }}</td>
              <td class="has-text-centered">{{ employee.rb4 }}</td>
              <td class="has-text-centered">{{ employee.appeals }}</td>
              <td class="has-text-centered">{{ employee.other }}</td>
            </tr>
          </template>
          <template v-if="employeesOverdueDocumentsByRegisterBooksData.length === 0">
            <tr>
              <td colspan="9">
                <section class="section">
                  <div class="content is-fluid has-text-grey has-text-centered">
                    <p>{{ $t('reports.nothingFound') }}</p>
                  </div>
                </section>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapGetters, mapState, mapActions} from 'vuex'
  import {prepareDate, userDetail, objectToURLParams, outputFile} from '@/utils'
  import {API_HOST} from '@/localSettings'

  export default {
    components: {
      DashboardLayout
    },
    methods: {
      userDetail,
      goTo(route) {
        this.$router.push({name: route})
      },
      loadData(excel = false) {
        this.$store.dispatch('Reports/getEmployeesOverdueDocumentsByRegisterBooks', {export: excel}).then(() => {
          if(excel) {
            outputFile('report.doc', this.exportData)
          }
        })
      },
    },
    mounted() {
      this.$store.commit('Reports/CLEAR', 'employeesOverdueDocumentsByRegisterBooksData')
      this.loadData()
    },
    computed: {
      ...mapState('Reports', ['employeesOverdueDocumentsByRegisterBooksData', 'exportData']),
      breadcrumbs() {
        return [
          {name: 'reportsList', path: 'reportsList'},
          {name: 'employeesOverdueDocumentsByRegisterBooks'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
